// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603311129/js/" + chunkId + "." + {"44":"3df03930","225":"d98b25d8","481":"8a302d18","486":"61e6412f","770":"df828458"}[chunkId] + ".0.2720920224344583.chunk.js";
};